/* prettier-ignore */

import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
import { catchError, of, throwError } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { LegalTextsComponent } from '../legal-texts/legal-texts.component';
import Swal from'sweetalert2';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})

export class RegisterComponent {
    passwordType: any = 'password';
    public registerForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      checkBox: new FormControl(false, [Validators.requiredTrue]),
      confirmPassword: new FormControl('', Validators.required)
    }, { validators: this.checkPasswords });
    
  constructor(
    public modalCtrl: ModalController, 
    public authService: AuthService,
    public userService: UserService,
    public tools: ToolsService,
    public translate: TranslateService,
    public modalController: ModalController
  ) {
    this.checkPasswords = this.checkPasswords.bind(this);
  }

  get f() { 
    return this.registerForm.controls; 
  }

  dismissModal(){
    this.modalCtrl.dismiss().catch(e => {
      console.warn("No modal found on dismiss")
    });
  }

  showPassword(){
    this.passwordType = this.passwordType == 'password' ? 'text' : 'password'
  }

  getIconStatus(){
    return this.passwordType === 'password' ? 'eye-off' : 'eye'
  }

  checkPasswords(group: FormGroup) {
    const password = group.get('password').value;
    const confirmPassword = group.get('confirmPassword').value;
    return password === confirmPassword ? null : { notSame: true };
  }

  register(){
    if (!this.registerForm.valid) return;
    const payload = { email: this.registerForm.get('email').value, password: this.registerForm.get('password').value }
    this.authService.register(payload.email, payload.password)
    .pipe(
        catchError((err) => {
          const error =  typeof err?.error?.errors === 'object' 
            ? Object.values(err?.error?.errors)?.flat()
            : []

          this.showError(error);
          return throwError(() => new Error('HTTP request failed', { cause: err }));
        })
      )
    .subscribe((res: any) => { 
      if (res.status === 'OK'){
          Swal.fire({
            title: '',
            text: this.translate.instant('Registrado correctamente'),
            icon: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer || result.dismiss === Swal.DismissReason.backdrop) 
              this.login(payload)
          })
          return;
      }
      this.showError();
    })
  }

  showError(err = []){
    if (err.length === 0){
      Swal.fire({ icon: 'error', title: '', text: this.translate.instant(`Ha ocurrido un error al intentar registrarse`) })
      return;
    }
    const errors = err.map(e => this.translate.instant(e)).join('\n');
    Swal.fire({ icon: 'error', title: '', text: errors})
  }

  login(payload){
    this.authService.login(payload.email, payload.password, false).subscribe((res: any) => { 
      if (res) 
        this.userService.checkAllUserEntries();
      this.dismissModal();
    })
  }

  get checkConditions(){
    return this.registerForm.get('checkBox')?.value || false;
  }

  focusin(evt) {
    evt.stopPropagation();
  } 

  async openPrivacyModal(){
    const modal = await this.modalController.create({
      component: LegalTextsComponent,
      cssClass: ['pdfModal', 'ion-disable-focus-trap'],
      componentProps: { type: 'privacy_policy'}
    });
    await modal.present();
  }

}